import { WarningAmber } from '@mui/icons-material';
import { DialogTitle, Grid, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

export default function ExpressVerificationWarning({
  open,
  setOpen,
  onProceed
}: {
  open: boolean,
  setOpen: (b: boolean) => void,
  onProceed: () => void
}) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="xs">
      <DialogTitle id="alert-dialog-title" color="warning">
        <Typography
          variant="h6"
          color="secondary"
          sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }}>
          Warning&nbsp; <WarningAmber fontSize="large" />{' '}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <ul style={{ marginLeft: '2em' }}>
          <Typography component={'li'}>
            Some of the selected verifications do not support the fast-track service.
          </Typography>
          <Typography component={'li'}>
            If you add a verification that does not support fast-track, it will affect the overall
            verification time.
          </Typography>
          <Typography component={'li'}>
            Fast-tracked verifications will still be completed within the guaranteed time.
          </Typography>
        </ul>
      </DialogContent>
      <DialogActions>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Button
              onClick={handleClose}
              variant="outlined"
              sx={{ width: '100%', padding: '10px 8px' }}>
              Cancel
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              onClick={() => {
                handleClose();
                onProceed();
              }}
              variant="contained"
              color="primary"
              autoFocus
              sx={{ width: '100%', padding: '10px 8px' }}>
              Proceed
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
